<div id="autonomo-fin" class="container__autonomo-fin form-width-size first-container-options-xs d-flex justify-content-center align-items-center flex-column position-relative m-t-xs-20" action="">
    <div class="p-y-11 p-y-sm-0 p-y-xs-0 m-t-25 m-t-sm-12 m-t-xs-70">
      <div class="d-block m-b-40 w-100">        
        <p class="autonomo__title">
          ¡Gracias, <span class="first-letter-capitalize">{{name | titlecase}}</span>!       
        </p>       
        <p class="autonomo__paragraph">
          El folio para la creación de tu cuenta Bursanet Sin Límites es {{generalData.cx_folio}}. <br><br>

          En breve un ejecutivo se pondrá en contacto vía email para continuar tu proceso de apertura. Recuerda revisar tu
          carpeta de Spam. <br><br>
  
          Mientras tanto, puedes fortalecer tus conocimientos sobre inversiones en <a
          class="link-generic-style" href="https://www.acelera-academy.com/" target="_blank">Acelera Academy de Actinver</a>. <br><br>
  
          Si tienes dudas o comentarios te atenderemos de lunes a viernes entre 8:00 y 18:00 hrs en el <a
            class="link-generic-transparent" href="tel:55 5268 0807">55 5268 0807</a> o escríbenos a <a
            class="link-generic-style"
            href="mailto:aperturasbursanet@actinver.com.mx">aperturasbursanet&#64;actinver.com.mx</a>
        </p>
        <div class="container__social__style">
          <a class="link__social" [href]="url.social_network.facebook" target="_blank" (click)="gtagSocial('FB')"><img [src]="img.social_network.facebook" alt=""></a>
          
          <a class="link__social" [href]="url.social_network.instagram" target="_blank" (click)="gtagSocial('IG')"><img [src]="img.social_network.instagram" alt=""></a>
          <a class="link__social" [href]="url.social_network.ex" target="_blank" (click)="gtagSocial('T')"><img [src]="img.social_network.ex" alt=""></a>
        </div>
      </div> 
    </div>
  </div>